import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["startDate", "endDate"];

  declare readonly startDateTarget: HTMLInputElement;
  declare readonly endDateTarget: HTMLInputElement;

  prevMonth(event: Event): void {
    event.preventDefault();
    const currentDate = this.getCurrentDate();
    currentDate.setMonth(currentDate.getMonth() - 1);
    this.setMonthRange(currentDate);
  }

  currentMonth(event: Event): void {
    event.preventDefault();
    this.setMonthRange(new Date());
  }

  nextMonth(event: Event): void {
    event.preventDefault();
    const currentDate = this.getCurrentDate();
    currentDate.setMonth(currentDate.getMonth() + 1);
    this.setMonthRange(currentDate);
  }

  private getCurrentDate(): Date {
    if (this.startDateTarget.value) {
      return new Date(this.startDateTarget.value);
    }
    const lastMonth = new Date();
    lastMonth.setMonth(lastMonth.getMonth() - 1);
    return lastMonth;
  }

  private setMonthRange(date: Date): void {
    const startOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);
    const endOfMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0);

    this.startDateTarget.value = this.formatDate(startOfMonth);
    this.endDateTarget.value = this.formatDate(endOfMonth);
    this.startDateTarget.dispatchEvent(new Event("change", { bubbles: true }));
  }

  private formatDate(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }
}
